import type { Me } from "../types.ts";
import { useApiQuery } from "./use-api-query.ts";

export const useMe = () => {
  return useApiQuery<Me>("/me", {
    refetchInterval: undefined,
    refetchOnWindowFocus: false,
    refetchOnReconnect: true,
  });
};
